import { useRef, useState } from "react";
import AudioPlayer from "react-h5-audio-player";
import "react-h5-audio-player/lib/styles.css";
import { Play, Pause, Volume2, VolumeX } from "lucide-react";

const CustomAudioPlayer = ({ url }: { url: string }) => {
	const playerRef = useRef<any>(null);
	const [isPlaying, setIsPlaying] = useState(false);
	const [isMuted, setIsMuted] = useState(false);
	return (
		<div className="w-full max-w-xl mx-auto rounded-xl border p-4 flex items-center justify-between gap-3 my-3">
			{/* Play / Pause */}
			<button
				onClick={() => {
					if (isPlaying) {
						playerRef.current.audio.current.pause();
					} else {
						playerRef.current.audio.current.play();
					}
				}}
				className="text-gray-500 dark:text-gray-100 hover:scale-110 transition"
			>
				{isPlaying ? <Pause size={25} /> : <Play size={25} />}
			</button>

			{/* Volume */}
			<button
				onClick={() => {
					const audio = playerRef.current.audio.current;
					audio.muted = !audio.muted;
					setIsMuted(audio.muted);
				}}
				className="text-gray-500 dark:text-gray-300 hover:scale-110 transition"
			>
				{isMuted ? <VolumeX size={24} /> : <Volume2 size={24} />}
			</button>

			{/* Hidden Player */}
			<AudioPlayer
				ref={playerRef}
				src={url}
				onPlay={() => setIsPlaying(true)}
				onPause={() => setIsPlaying(false)}
				autoPlayAfterSrcChange={false}
				showJumpControls={false}
				showDownloadProgress={false}
				customControlsSection={[]}
				customAdditionalControls={[]}
				customVolumeControls={[]}
				className="hidden border shadow-none rounded-lg"
			/>
		</div>
	);
};

export default CustomAudioPlayer;
